import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";

export const WhatsAppButton = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-floating-button"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#1fb658] text-white pl-4 pr-5 py-3.5 rounded-full shadow-2xl transition-transform duration-300 hover:scale-105"
  >
    <span className="relative flex h-6 w-6 items-center justify-center">
      <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 animate-ping" />
      <MessageCircle className="relative h-6 w-6" />
    </span>
    <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
  </a>
);
